import { render } from "./ProductDetailView.vue?vue&type=template&id=7cc80fbf&scoped=true&ts=true"
import script from "./ProductDetailView.vue?vue&type=script&lang=ts"
export * from "./ProductDetailView.vue?vue&type=script&lang=ts"

import "./ProductDetailView.vue?vue&type=style&index=0&id=7cc80fbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc80fbf"]])

export default __exports__